export default function getFormData(files, name) {
  const formData = new FormData();

  Array.from(files).forEach(file => {
    formData.append(name, file);
  });

  return formData;
}
